<template>
    <div>
        <div class="row my-3">
            <div class="col-6">
                <router-link to="/membership/order" class="btn w-auto"><icon icon="plus-circle" /> {{$t('ORDER_A_MEMBERSHIP')}}</router-link>
            </div>
        </div>

        <div class="card shadow mb-4">
            <div class="card-header card-header-main">
                <h6 class="m-0 font-weight-bold text-primary col-2">{{$t('ORDERS')}}</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive mb-3">
                    <b-table show-empty
                            hover
                            bordered
                            :items="orders"
                            :fields="fields">
                        <template v-slot:cell(hash)="row">
                            {{ row.value }}
                        </template>
                        <template v-slot:cell(start)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
                        <template v-slot:cell(end)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
                        <template v-slot:cell(paymentDate)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
                        <template v-slot:cell(processed)="row">
                            <input type="checkbox" disabled :checked="row.value" />
                        </template>
                        <template v-slot:cell(createdOn)="row">
                            {{ row.value.replace('T', ' ').slice(0,19) }}
                        </template>
<!--                        <template v-slot:cell(details)="row">-->
<!--                            <button @click="details(row.item)" class="btn btn-primary">Details</button>-->
<!--                        </template>-->
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>export default {
        data() {
            return {
                orders: [],
            }
        },
        computed: {
            fields() {
                return [
                    { key: 'hash', label: this.$t('ORDER_NUMBER'), sortable: true },
                    { key: 'start', label: this.$t('START_DATE'), sortable: true },
                    { key: 'end', label: this.$t('END_DATE'), sortable: true },
                    { key: 'paymentDate', label: this.$t('PAYMENT_DAY'), sortable: true },
                    { key: 'processed', label: this.$t('PROCESSED'), sortable: true },
                    { key: 'createdOn', label: this.$t('REQUESTED_ON'), sortable: true },
                    // { key: 'details', label: this.$t('DETAILS'), tdClass: 'fit' },
                ]
            }
        },
        methods: {
            loadMembershipOrders() {
                let self = this;
                this.$http.get("/api/membership/orders")
                    .then(response => {
                        self.orders = response.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })
            }
        },
        mounted() {
            this.loadMembershipOrders();
        }
    }</script>
<style lang="scss" scoped>
    .card-header {
        background-color: white;
        h6 {
            color: black !important;
        }
    }
</style>